import { useState } from "react";

export default function TableHeader({ label, field, onSort, onFilter }) {
  const [showFilter, setShowFilter] = useState(false);

  const handleDoubleClick = () => {
    onSort(field);
  };

  return (
    <th
      className="border px-2 py-1 relative select-none cursor-pointer"
      onDoubleClick={handleDoubleClick}
    >
      <div className="flex items-center justify-between">
        {label}
        <span
          className="ml-1 w-2 h-2 bg-gray-500 rounded-full hover:bg-gray-700"
          onClick={(e) => {
            e.stopPropagation();
            setShowFilter(!showFilter);
          }}
        />
      </div>

      {showFilter && (
        <div className="absolute top-full left-0 bg-white shadow-md p-2 z-10">
          <input
            type="text"
            placeholder={`Filter ${label}`}
            className="border p-1 text-xs w-32"
            onChange={(e) => onFilter(field, e.target.value)}
          />
        </div>
      )}
    </th>
  );
}
